import { useMemo } from 'react';
import { freeze } from '@reduxjs/toolkit';
import { useAppDispatch } from '../../../../redux/hooks';
import {
  setChartSettingGeoMapDisplayedMeasureKeyAction,
  setChartSettingGeoMapHeatmapAction,
} from '../../../../redux/slices/analyses';
import { assertCondition } from '../../../../utils/types';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import { SingleSelectMenu } from '../../../Dropdown';
import { ISingleSelectMenuOption } from '../../../Dropdown/SingleSelectMenu/types';
import { useChartContext } from '../../ChartContext';
interface IProps {
  analysisId: string;
}

const geoHeatMapOptions = freeze<ISingleSelectMenuOption[]>(
  [
    {
      text: 'Area Map',
      value: 'areamap',
    },
    {
      text: 'Heat Map',
      value: 'heatmap',
    },
  ],
  true,
);

const GeoMapControls = ({ analysisId }: IProps) => {
  const dispatch = useAppDispatch();
  const {
    settings: { chartSettings },
    displayedMeasures,
    chartData,
  } = useChartContext();
  const { geoMapConfig } = chartSettings;
  assertCondition(chartData?.queryType === QueryType.Expression);

  const onMapTypeChange = (newValue: string) => {
    dispatch(
      setChartSettingGeoMapHeatmapAction({
        analysisId,
        isHeatmap: newValue === 'heatmap',
      }),
    );
  };

  const onDisplayedMeasureChange = (newValue: string) => {
    dispatch(
      setChartSettingGeoMapDisplayedMeasureKeyAction({
        analysisId,
        displayedMeasureKey: newValue,
      }),
    );
  };

  const displayedMeasureOptions = useMemo<ISingleSelectMenuOption[]>(
    () =>
      displayedMeasures.map((measure) => ({
        text: measure.label
          ? `${measure.label}: ${measure.name}`
          : measure.name,
        value: measure.key,
      })),
    [displayedMeasures],
  );

  const mapValue = geoHeatMapOptions[geoMapConfig.isHeatmap ? 1 : 0].value;

  return (
    <>
      <SingleSelectMenu
        options={geoHeatMapOptions}
        value={mapValue}
        onChange={onMapTypeChange}
      />
      <SingleSelectMenu
        options={displayedMeasureOptions}
        value={geoMapConfig.displayedMeasureKey}
        onChange={onDisplayedMeasureChange}
      />
    </>
  );
};

export default GeoMapControls;
